import { ThemeContext } from "styled-components";
import { useState, useEffect, useRef, useContext } from "react";
export const useOverlay = (isOpen) => {
    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [isOpen]);
};
export function useMediaQuery(query) {
    const [matches, setMatches] = useState(false);
    useEffect(() => {
        const media = window.matchMedia(query);
        if (media.matches !== matches) {
            setMatches(media.matches);
        }
        const listener = () => {
            setMatches(media.matches);
        };
        media.addEventListener("change", listener);
        return () => media.removeEventListener("change", listener);
    }, [matches, query]);
    return matches;
}
export const useIsMobile = () => {
    const { mediaQueries: { mobile }, } = useContext(ThemeContext);
    return useMediaQuery(mobile);
};
export const useInput = (value, onChange, onChangeTimeout = 400) => {
    const [text, setText] = useState(value);
    const tid = useRef(null);
    // improves performance in forms
    useEffect(() => {
        if (text !== value) {
            tid.current && clearTimeout(tid.current);
            tid.current = setTimeout(() => onChange(text), onChangeTimeout);
        }
    }, [text]);
    useEffect(() => {
        setText(value);
    }, [value]);
    return { text, setText };
};
export const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
};
export const useDivTop = () => {
    const ref = useRef();
    const [divTop, setDivTop] = useState();
    useEffect(() => {
        const setTop = () => { var _a; return setDivTop((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().top); };
        setTop();
        window.addEventListener("resize", setTop);
        return () => {
            window.removeEventListener("resize", setTop);
        };
    }, []);
    return { ref, divTop };
};
export const useWindowInnerHeight = () => {
    const [windowInnerHeight, setInnerHeight] = useState(window.innerHeight);
    useEffect(() => {
        const _setInnerHeight = () => setInnerHeight(window.innerHeight);
        _setInnerHeight();
        window.addEventListener("resize", _setInnerHeight);
        return () => {
            window.removeEventListener("resize", _setInnerHeight);
        };
    }, []);
    return windowInnerHeight;
};
export const useWindowInnerSize = () => {
    const [innerSize, setInnerSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });
    useEffect(() => {
        const _setInnerSize = () => {
            setInnerSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };
        _setInnerSize();
        window.addEventListener("resize", _setInnerSize);
        return () => {
            window.removeEventListener("resize", _setInnerSize);
        };
    }, []);
    return innerSize;
};
export const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        const timer = setTimeout(() => setDebouncedValue(value), delay || 500);
        return () => {
            clearTimeout(timer);
        };
    }, [value, delay]);
    return debouncedValue;
};
export const useClickOutside = (ref, onClickOutside) => {
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref && !ref.contains(event.target)) {
                onClickOutside(event);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
};
//# sourceMappingURL=hooks.js.map